var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',_vm._l((_vm.trail),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"to":item.navigation}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }